import styled from "@emotion/styled";
import anime from 'animejs';
import Image from 'gatsby-image';
import TransitionLink from 'gatsby-plugin-transition-link';
// import Link from 'gatsby-link';
import React from "react";
import { H2 } from '../grid/typography.component';

const exitAnimationDuration = 800;
const enterAnimationDelay = 300;

class ProductCard extends React.Component {

  constructor() {
    super()

    this.heroImage = React.createRef();
  }

  shouldComponentUpdate(nextProps, nextState) {

    const { transitionStatus, entry, exit } = nextProps;
    // console.log('- Render Product Card (shouldComponentUpdate)', nextProps.transitionStatus);

    return transitionStatus.indexOf('exit') < 0;
  }
  exitAnimation({ node, e, exit, entry }) {
    // console.log(exit);
    // console.log(entry);

    const target = this.heroImage.current;
    const targetBounds = target.getBoundingClientRect();
    target.classList.add('zoom');
    anime({
      targets: target,
      top: [`${Math.round(targetBounds.top)}px`, 0],
      left: [`${Math.round(targetBounds.left)}px`, 0],
      width: [targetBounds.width, window.innerWidth],
      height: [targetBounds.height, window.innerHeight],
      duration: exitAnimationDuration,
      easing: 'easeOutQuart'
    })
  }
  render() {
    const { productcase, title, mainimage, card_image, uid, card_size, transitionStatus } = this.props;
    console.log('--- Render Product Card', transitionStatus);

    let WrapperCell = card_size === 'normal' ? CellNormal : CellWide;
    const thumb = card_size === 'normal' ? card_image.localFile.childImageSharp.fluid : card_image.Wide.localFile.childImageSharp.fluid;
    return (
      <WrapperCell className="default-fade">
        <Product size={card_size}>
          <TransitionLink
            to={`/${productcase ? productcase.uid : 'demo'}/${uid}`}
            exit={{
              length: exitAnimationDuration / 1000,
              // zIndex: 2,
              trigger: ({ node, e, exit, entry }) => this.exitAnimation({ node, e, exit, entry })
              // here node refers to the DOM node of the exiting page
            }}
            entry={{
              length: 0,
              // zIndex: 0,
              // trigger: ({ node, e, exit, entry }) => console.log(node, e, exit, entry),
              delay: enterAnimationDelay / 1000,
            }}
          >
            <div className="image-wrapper-hero" ref={this.heroImage}>
              <div className="image-wrapper-hero-wrapper">
                <H2>{title.text}</H2>
                {mainimage && mainimage.localFile && <Image fluid={mainimage.localFile.childImageSharp.fluid} />}
              </div>
            </div>
            <div className="image-wrapper">
              <Image fluid={thumb} />
            </div>
          </TransitionLink>
        </Product>
      </WrapperCell>
    )
  }
}

export default ProductCard


const CardHeight = '33vw';

const CellNormal = styled.div`
  flex: 1 1 50%;
  max-width: 50%;
  @media (min-width: 800px){
    flex: 1 1 33.33333333%;
    max-width: 33.33333333%;
  }
`;
const CellWide = styled.div`
  flex: 1 1 100%;
  max-width: 100%;
  @media (min-width: 800px){
    flex: 1 1 66.666666666%;
    max-width: 66.666666666%;
  }
`;

const Product = styled.div`
  padding: 12px;

  a{
    display: block;
    width: 100%;
    height: ${CardHeight};
    color: #fff;
    position: relative;

    *{
      pointer-events: none;
    }
    
  }
  .gatsby-image-wrapper{
    height: 100%;
  }
  .image-wrapper{
    overflow: hidden;
    /*
    height: ${CardHeight}; */
    width: 100%;
    height: 100%;
  }
  .image-wrapper-hero{
    position: absolute;
    z-index: 10;
    width: 100%;
    height: ${CardHeight};
    overflow: hidden;
    
    h2{
      position: absolute;
      top: 50%;
      left: -50%;
      width: 100%;
      width: 200%;
      z-index: 1;
      margin: 0;
      transform: translateY(-50%) scale(.5);
      
    }
  }
  /* .tl-wrapper-status--entered &{ */

    .image-wrapper-hero{

      .image-wrapper-hero-wrapper{
        transform: translateY(100%);
        transition: transform 500ms;
        height: 100%;
      }
    }

    a:hover .image-wrapper-hero .image-wrapper-hero-wrapper{
      transform: translateY(0%);
    }
    .image-wrapper-hero.zoom{
      position: fixed;
      z-index: 2000;
      .image-wrapper-hero-wrapper{
        transition: transform ${exitAnimationDuration}ms;
        transform: translateY(0%) scale(1);
      }

      h2{
        transition: transform ${exitAnimationDuration}ms;
        transform: translateY(-50%) scale(1);
        
      }
    }
`